import './search';
import './header';
import './cart';
import './admin';
import './catalog';
import './checkout';

// ready dom event
document.addEventListener('DOMContentLoaded', () => {
    const body = document.body
    const filtersArea = document.querySelector('#secondary')
    const openFilterBtn = document.querySelector('.filter-mobile-btn')

    if (!filtersArea || !openFilterBtn) {
        return
    }

    function isFilterOpen() {
        return filtersArea.classList.contains('visible')
    }

    function openFilter() {
        body.classList.add('filter-menu-visible')
        filtersArea.classList.add('visible')
    }

    function closeFilter() {
        body.classList.remove('filter-menu-visible')
        filtersArea.classList.remove('visible')
    }

    openFilterBtn.addEventListener('click', (e) => {
        if (isFilterOpen()) {
            closeFilter()
        } else {
            openFilter()
        }
        e.stopPropagation();
    })

    document.addEventListener('click', (e) => {
        if (!e.target.closest('#secondary')) {
            closeFilter()
            e.stopPropagation();
        }
    })
})

jQuery(($) => {
   $(document.body).on('update_checkout', function() {
       ['billing', 'shipping'].forEach(selector => {
           const $state = $(`select#${selector}_state`)
           const $postcode = $(`input#${selector}_postcode`)
           const newState = $postcode.val()?.[0];
           const options = $state.children('option').map((a, b) => jQuery(b).val()).toArray().filter(Boolean)
           if (newState && $state.val() !== newState && options.includes(newState)) {
               $state.val(newState)
               $state.trigger('change')
           }
       })
   })
})
